import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../app-actions';

const withSubscriptions = (WrappedComponent) => {
    return connect(
        mapStateToProps,
        mapDispatchToProps,
    )(WrappedComponent);
};

const mapDispatchToProps = dispatch => bindActionCreators({
    checkSubscription: AppActions.checkSubscription,
    createSubscription: AppActions.createSubscription,
    getNextSubscription: AppActions.getNextSubscription,
    updateNextSubscription: AppActions.updateNextSubscription,
    cancelSubscription: AppActions.cancelSubscription,
    getCurrency: AppActions.getCurrency,
    getCountry: AppActions.getCountry,
    getCoupons: AppActions.getCoupons,
    getCoupon: AppActions.getCoupon,
    clearCoupon: AppActions.clearCoupon,
    getCouponApplied: AppActions.getCouponApplied,
}, dispatch);

function mapStateToProps(state) {
    const {
        subscriptions, subscriptionsLoading, subscriptionsError,
        nextSubscription, nextSubscriptionLoading, nextSubscriptionError,
        currency, currencyLoading, currencyError,
        country, countryLoading, countryError,
        coupons, couponsLoading, couponsError,
        coupon, couponLoading, couponError,
        couponApplied, couponAppliedLoading, couponAppliedError,
    } = state;
    return {
        subscriptions, subscriptionsLoading, subscriptionsError,
        nextSubscription, nextSubscriptionLoading, nextSubscriptionError,
        currency, currencyLoading, currencyError,
        country, countryLoading, countryError,
        coupons, couponsLoading, couponsError,
        coupon, couponLoading, couponError,
        couponApplied, couponAppliedLoading, couponAppliedError,
    };
}

export default (withSubscriptions);
